import { TapStreamWriter } from './frame/tap-stream-core';

const generatedWriteApduRequestHeader =
  TapStreamWriter.prototype.writeApduRequestHeader;

TapStreamWriter.prototype.writeApduRequestHeader = function (model) {
  if (model.lc > 0xff) {
    this.writeUnsigned(model.cla, 1);
    this.writeUnsigned(model.ins, 1);
    this.writeUnsigned(model.p1, 1);
    this.writeUnsigned(model.p2, 1);
    this.writeUnsigned(0, 1);
    this.writeUnsigned(model.lc, 2);
    return this;
  } else {
    return generatedWriteApduRequestHeader.apply(this, [model]);
  }
};

export * from './generated/converter';

import './generated/converter-stream-extension';
